import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

const app = (
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// react-snap pre-renders static HTML into #root at build time.
// Hydrate that markup in production; render fresh in dev.
if (rootElement.hasChildNodes()) {
    ReactDOM.hydrateRoot(rootElement, app);
} else {
    ReactDOM.createRoot(rootElement).render(app);
}
